import styled from 'styled-components'
import { Box, Text, Button } from '@usap/uicomponents'

const tabletBreakpoints = props => props.theme.mediaQuery.up('tablet-landscape');
const borderColor = props => props.theme.global.colors['light-7']

export const CouponsMainContainer = styled(Box)`
  background: url('${({ bgImage }) => bgImage || ''}') no-repeat fixed center;
  background-size: cover;
  min-height: 506px;
  justify-content: center;
  align-content: center;
  padding: 0px 40px;
  ${tabletBreakpoints} {
    min-height: 641px;
  }
`

export const CouponsInnerContainer = styled(Box)`
  padding: 24px 16px;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  ${tabletBreakpoints} {
    padding: 24px;
    max-width: 684px;
    min-height: 334px;
    margin: auto;
  }
  @media (max-width:384px) {
    padding: 24px 12px;
  }
`

export const FormInput = styled(Box)`
  padding-top: 8px;
  padding-bottom: 8px;
`

export const CouponTitleContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
`

export const CouponsTextContainer = styled.div`
  text-align: center;
  margin: 4px auto;
  width: 100%;
  ${tabletBreakpoints} {
    width: 100%;
  }
`

export const HeadingText = styled.div`
  font-size: 18px;
  line-height: 29.7px;
  font-weight: 600;
  text-wrap: nowrap;
  margin-top: 2px;
  ${tabletBreakpoints} {
    font-size: 24px;
    line-height: 36px;
    font-weight: 600;
    text-wrap: nowrap;
    margin-top: 2px;
  }
`

export const CouponsText = styled(Text)`
font-size: 14px;
line-height: 23.1px;
font-weight: 400;
  ${tabletBreakpoints} {
    font-size: 16px;
    line-height: 26.4px;
    font-weight: 400;
  }
`

export const SignUpNowBtn = styled(Button)`
  height: 40px;
  margin: 12px 0px;
  font-size: 14px;
  border-radius: 4px;
  ${tabletBreakpoints} {
    height: 48px;
    margin: 16px 0px;
    font-size: 14px;
    border-radius: 4px;
  }
`

export const CouponLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`

export const LinkText = styled.a`
  color: #05629B;
  text-decoration: underline;
  font-size: 14px;
  line-height: 23.1px;
  cursor: pointer;
`

export const MailLogoContainer = styled.div`
  display: flex;
  margin: auto;
  
`